import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { apiClient } from '../../api';
import { Agent } from '../../types/agentTypes';

const AGENTS_QUERY_KEY = ['agents'];

export const useAgents = () => {
  const { agentId } = useParams<{ agentId: string }>();

  // Query for fetching agents
  const {
    data: agents = [],
    isLoading: isLoadingAgents,
    error: agentError,
    refetch: fetchAgents,
  } = useQuery<Agent[]>({
    queryKey: AGENTS_QUERY_KEY,
    queryFn: apiClient.agent.fetchAgentsList,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  });

  const currentAgent = useMemo(() => agents.find(agent => agent.id === agentId), [agents, agentId]);

  return {
    // Data
    agents,
    currentAgent,
    isLoadingAgents,
    agentError: agentError?.message || null,

    // Actions
    fetchAgents,
  };
};
